import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import RichTextEditor, {
  EDITOR_UPLOAD_PENDING_MESSAGE,
  editorUploadsPending,
} from "../../components/RichTextEditor";
import tools from "../../utils/tools";

const CategoryManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});
  const [categories, setCategories] = useState([]);

  const send = async () => {
    // an editor image still uploading would be saved without its address
    if (editorUploadsPending()) {
      Swal.fire({
        title: "صبر کنید",
        text: EDITOR_UPLOAD_PENDING_MESSAGE,
        icon: "warning",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }
    dispatch(setLoading(true));

    const res = await restApi(
      endpoints.category.basic + (paramId || ""),
      true,
    ).post(tools.extractor(form, ["title", "description", "parentId", "slug"]));

    if (res.code == 200) {
      if (image.data) {
        const formData = new FormData();
        formData.append("file", image.data);
        await restApi(endpoints.category.medias + res.data.id, true).upload(formData);
      }
      Swal.fire({
        title: "موفق",
        text: `دسته بندی با موفقیت ${paramId ? "ویرایش" : "ساخته"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/category");
        },
      });
    } else if (res.code == 2001) {
      Swal.fire({
        title: "ناموفق",
        text: "URL تکراری میباشد",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    if (paramId) {
      const res = await restApi(endpoints.category.single + paramId, true).get();
      if (res.code == 200) {
        setForm({
          title: res.data?.title,
          description: res.data?.description,
          parentId: res.data?.parentId,
          slug: res.data?.slug,
        });
        setImage({
          data: undefined,
          preview: res.data.media?.url,
        });
      }
    }

    const result = await restApi(endpoints.category.index, true).get({ type: "children" });
    const sortedData = [];
    result.data.map((e) => tools.extractChildren(e, sortedData));
    if (result.code == 200) {
      setCategories(sortedData);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain main">
          <div className="addInfoHeader">
            <span className="dashboardHeader keepRight clickable" onClick={send}>
              {paramId ? "ویرایش " : "ایجاد "}دسته بندی
            </span>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه دسته بندی ها</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} دسته بندی
              </h1>
            </span>
            <i className="backAdd clickable" onClick={() => navigate("/category/")}></i>
          </div>
          <section className="bottomSection">
            <h1 className="dashBoardTitle">اطلاعات دسته بندی</h1>
            <form className="addInfo">
              <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
              <input
                className="addInput"
                id="infoTitle"
                onChange={(input: any) =>
                  setForm((prev) => ({ ...prev, title: input.target.value }))
                }
                value={form.title || ""}
              />
              <label>URL</label>
              <div className="rowReverse">
                <input
                  className="persianName halfWidth"
                  value={form.slug || ""}
                  onChange={(input) =>
                    setForm((prev) => ({ ...prev, slug: input.target.value }))
                  }
                />
                <label>
                  <a
                    href={`${process.env.REACT_APP_CLIENT_URL}/category/${form.slug}`}
                    target="_blank"
                  >{`${process.env.REACT_APP_CLIENT_URL}/category/`}</a>
                </label>
              </div>
              <label className="sideBarTitle">والد</label>
              <Select
                options={tools.selectFormatter(categories, "id", "title", "بدون والد")}
                value={tools.selectFormatter(
                  categories.filter((e) => e.id == form.parentId),
                  "id",
                  "title",
                )}
                className="width100"
                onChange={(selected) =>
                  setForm((prev) => ({ ...prev, parentId: selected.value.toString() }))
                }
              />
              <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
              <RichTextEditor
                value={form.description}
                onChange={(description) =>
                  setForm((prev) => ({ ...prev, description }))
                }
              />
              <input
                type="file"
                onChange={(input) =>
                  setImage({
                    data: input.target.files[0],
                    preview: URL.createObjectURL(input.target.files[0]),
                  })
                }
              />
            </form>
            <img src={image.preview} alt="تصویر" />
          </section>
        </main>
      </body>
    </>
  );
};
export default CategoryManage;
